import React from 'react';
import './PageHero.css';

function PageHero({ title }) {
  return (
    <div className="page-hero">
      <div className="page-hero-inner">
        <h1>{title}</h1>
      </div>
    </div>
  );
}

export default PageHero;
